<script setup>
import { computed } from 'vue';

const props = defineProps({
    containerRef: {
        type: String,
        required: true
    },
    uuid: {
        type: String,
        require: true
    },
    content: {
        type: Object,
        required: false
    }
})

const allowDownload = computed(() => {
    return props.content?.allowDownload !== false;
});
</script>

<template>
    <div class="my-8">
        <div class="bg-gray-200 text-black py-8 px-4 text-center rounded-wl relative overflow-hidden">

            <div>
                <button-primary class="mt-4 w-full max-w-md justify-center">{{ content.viewButtonLabel }}</button-primary>
            </div>
            <div>
                <button-secondary v-if="allowDownload" class="mt-4 w-full max-w-md justify-center"> Download</button-secondary>
            </div>

            <div class="bg-gray-400 text-black py-0.5 w-32 text-center absolute top-4 left-8 -rotate-45 text-xxs -translate-x-1/2">Placeholder</div>
        </div>
    </div>
</template>

<style scoped>
.pdf-viewer-container :deep(.download-button a) {
    color: inherit;
}
</style>
